"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = __importDefault(require("vue"));
var vue_property_decorator_1 = require("vue-property-decorator");
var leaflet_1 = require("leaflet");
var vue2_leaflet_1 = require("vue2-leaflet");
var vue2_leaflet_vectorgrid_1 = __importDefault(require("vue2-leaflet-vectorgrid"));
var parameters_1 = __importDefault(require("@/config/parameters"));
var filters_1 = require("@/filter/filters");
var MapFeaturedTrip = /** @class */ (function (_super) {
    __extends(MapFeaturedTrip, _super);
    function MapFeaturedTrip() {
        var _a, _b;
        var _this = _super.call(this) || this;
        _this.tileServerUrl = parameters_1.default.mapConfiguration.tileServerUrl;
        _this.tileServerAttribution = parameters_1.default.mapConfiguration.attribution;
        _this.loader = true;
        _this.zoom = 16;
        _this.center = new leaflet_1.LatLng((_a = _this.partnership.country) === null || _a === void 0 ? void 0 : _a.gps_latitude, (_b = _this.partnership.country) === null || _b === void 0 ? void 0 : _b.gps_longitude);
        _this.routeExtended = {
            collections: []
        };
        _this.focusedPoiId = null;
        _this.partnershipRoutesTileServer = parameters_1.default.mapConfiguration.partnershipRoutesTileServerUrl + "/" + _this.$route.params.partnershipSlug + "/{z}/{x}/{y}.pbf";
        _this.partnershipRoutesOptions = {
            interactive: true,
            maxNativeZoom: 14,
            vectorTileLayerStyles: {
                "santiagodecompostela": parameters_1.default.mapConfiguration.pathStyles.partnershipRoutesBackground,
                "rome": parameters_1.default.mapConfiguration.pathStyles.partnershipRoutesBackground,
                "saintolav": parameters_1.default.mapConfiguration.pathStyles.partnershipRoutesBackground,
                "csiksomlyo": parameters_1.default.mapConfiguration.pathStyles.partnershipRoutesBackground,
            }
        };
        _this.pointOfInterestIcon = new leaflet_1.Icon({
            iconUrl: require('@/assets/images/Markers/SimpleMarker.png'),
            iconSize: [40, 40],
            iconAnchor: [20, 40],
            popupAnchor: [1, -34],
            shadowSize: [41, 41],
        });
        return _this;
    }
    MapFeaturedTrip.prototype.beforeMount = function () {
        this.$emit('routeExtendedLoading');
    };
    MapFeaturedTrip.prototype.mounted = function () {
        var _this = this;
        var routeExtendedRequest = {
            partnership_slug: this.$route.params.partnershipSlug,
            featured_plan: {
                route: this.featuredTrip.route,
                transport_id: this.featuredTrip.transport.id
            }
        };
        this.$routeExtendedCalculatorService.request_from_featured_plan(routeExtendedRequest).then(function (response) {
            _this.routeExtended = response;
            _this.$emit('routeExtendedReady');
        }).finally(function () { return _this.$emit('routeExtendedLoading'); });
    };
    MapFeaturedTrip.prototype.getStyle = function (highlighted) {
        if (highlighted) {
            return parameters_1.default.mapConfiguration.pathStyles.partnershipRoutes;
        }
        else {
            return parameters_1.default.mapConfiguration.pathStyles.partnershipRoutesBackground;
        }
    };
    MapFeaturedTrip.prototype.setBounds = function () {
        this.$refs.MapViewer.fitBounds(this.featuredTrip.route.route_points_of_interest.map(function (poi) {
            return [
                poi.point_of_interest.gps_latitude,
                poi.point_of_interest.gps_longitude
            ];
        }));
    };
    MapFeaturedTrip.prototype.changeSizeContainer = function () {
        var _this = this;
        setTimeout(function () {
            _this.$refs.MapViewer.mapObject.invalidateSize();
            _this.setBounds();
        });
    };
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], MapFeaturedTrip.prototype, "featuredTrip", void 0);
    __decorate([
        vue_property_decorator_1.Prop({ required: true })
    ], MapFeaturedTrip.prototype, "partnership", void 0);
    MapFeaturedTrip = __decorate([
        vue_property_decorator_1.Component({
            name: 'MapRouteExtendedViewer',
            components: {
                LMap: vue2_leaflet_1.LMap,
                LTileLayer: vue2_leaflet_1.LTileLayer,
                LControlLayers: vue2_leaflet_1.LControlLayers,
                LMarker: vue2_leaflet_1.LMarker,
                LIcon: vue2_leaflet_1.LIcon,
                LControl: vue2_leaflet_1.LControl,
                LControlZoom: vue2_leaflet_1.LControlZoom,
                LFeatureGroup: vue2_leaflet_1.LFeatureGroup,
                LPolyline: vue2_leaflet_1.LPolyline,
                LTooltip: vue2_leaflet_1.LTooltip,
                LProtobuf: vue2_leaflet_vectorgrid_1.default
            },
            filters: {
                translation: filters_1.translation,
                coordinatesListSort: filters_1.coordinatesListSort
            }
        })
    ], MapFeaturedTrip);
    return MapFeaturedTrip;
}(vue_1.default));
exports.default = MapFeaturedTrip;
